<template>
    <div>
        <div class="upload-images">
             <div ref="preview" id="preview">
              <!-- <img v-if="images" :src="images" /> -->
              <figure  v-for="(item,index) in images" :key="index.id">
                <b-link class="text-danger" @click="deleteImage(index)"> 
                  <font-awesome-icon :icon="['fas', 'times']"  />
                </b-link>
                <img :src="item"  />
              </figure>
             </div>

                <b-row class="align-items-center fs-12 py-2">
                    <b-col md="8">
                        <!-- <b-link class="">
                        <font-awesome-icon class="ml-3 mr-2"
                            :icon="['fas', 'camera']"
                        />Add images
                        </b-link> -->
                    <b-form-group id="fileInput" class="dragdrop">
                         <font-awesome-icon class="ml-3 mr-2 float-left"
                            :icon="['fas', 'camera']"
                        />
                         <b-form-file 
                         v-model="file" 
                         accept="image/jpeg, image/png, image/gif" 
                         placeholder="Choose a file or drop it here..."
                         :file-name-formatter="formatNames"
                         @change="onFileChange($event)"
                         :disabled="checkImageLimit"
                         drop-placeholder="Drop file here..." ></b-form-file>
                    </b-form-group>
                   
                    </b-col>
                    <b-col md="4" class="text-right">
                        <p class="mb-0 text-muted mr-3">Upto 4 images</p>
                    </b-col>
                    <b-col md="12">
                     <!-- <div v-if="checkImageLimit==true" class="pl-3 text-danger">
                      Maximum 4 images allowed to upload.
                    </div> -->
                    </b-col>
                </b-row>
        </div>
    </div>
</template>

<script>

export default {
  name: "upload-image",
  components: { },
  computed: {
  },
  data() {
    return {
        file: null,
        previewImg: null,
        url:null,
        images:[]
        // checkImageLimit:false
    };
  },
  computed:{
    checkImageLimit(){
     return this.images.length >= 4 ? true : false
    }
  },
  watch:{
    // file(val) {
    //   if (!val) return;
    //   if (this.previewImg) {
    //     this.previewImg.remove();
    //   }
    //   const img = document.createElement("img");
    //   img.classList.add("obj");
    //   img.file = this.file;
    //   this.previewImg = img;
    //   this.$refs.preview.appendChild(img);
        
    //   const fileReader = new FileReader();
    //   fileReader.onload = (e) => { this.previewImg.src = e.target.result; };
    //   fileReader.readAsDataURL(this.file);
    // }
    
  },  
  methods: {
    formatNames(files){
      return files.length === 1 ? files[0].name : `${files.length} images selected` 
    },
    onFileChange(e){
      const file = e.target.files[0];
      this.images.push(URL.createObjectURL(file))
      // console.log(url)
      // this.images.push(url)
    },
    deleteImage(index){
      this.images.splice(index, 1)
    }
  }
};

</script>

<style lang="scss" scoped>
.upload-images{
    .fa-camera{
        color:$blue-color;
    }
}
</style>